import styled, { css } from 'styled-components';
export const Title = styled.span `
  text-align: left;
  ${({ theme: { calendarHeading } }) => calendarHeading}
  ${({ theme: { selectedOptionTitle } }) => selectedOptionTitle}
`;
export const Value = styled.span `
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ theme: { accent, selectedOptionValue } }) => css `
    ${selectedOptionValue};
    color: ${accent || 'var(--primary-medium)'};
  `}
`;
export const DummyLink = styled.span `
  text-decoration: underline;
  color: var(--primary-medium);
  cursor: pointer;
  text-align: right;
  flex: 1 0 13.8rem;
  ${({ theme: { selectedOptionDummyLink } }) => selectedOptionDummyLink}
`;
export const Wrapper = styled.button `
  appearance: none;
  -webkit-appearance: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  width: 100%;
  border: none;
  cursor: pointer;
  padding: 1.9rem 1rem 1.5rem;
  position: relative;
  z-index: 3;
  ${({ theme: { selectedOptionWrapper } }) => selectedOptionWrapper}
`;
export const Icon = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
  margin-right: 0.8rem;
`;
export default {
    Title,
    Value,
    DummyLink,
    Wrapper,
    Icon,
};
